export default __webpack_public_path__ + "static/media/LogoSURA.189a2ca2.svg";